/* eslint-disable class-methods-use-this */
import type { IGlobalTab, IInnerTab } from '@carboncopyco/types/desktop';

// Service that is sending messages to the main process.
class RendererService {
  private hasOpenModals = false;

  setHasOpenModals(value: boolean) {
    this.hasOpenModals = value;
  }
  getHasOpenModals() {
    return this.hasOpenModals;
  }
  createGlobalTab(tab: IGlobalTab) {
    return window.dsDesktop.tabs.createGlobalTab(tab);
  }
  createInnerTab(globalTab: IGlobalTab, innerTab: IInnerTab) {
    window.dsDesktop.tabs.createInnerTab(globalTab, innerTab);
  }
  navigateGlobalTab(tab: IGlobalTab) {
    window.dsDesktop.tabs.navigateGlobalTab(tab);
  }
  navigateInnerTab(tab: IInnerTab) {
    window.dsDesktop.tabs.navigateInnerTab(tab);
  }
  async closeGlobalTab(tab: IGlobalTab) {
    return window.dsDesktop.tabs.closeGlobalTab(tab);
  }
  closeInnerTab(tab: IInnerTab) {
    window.dsDesktop.tabs.closeInnerTab(tab);
  }
  navigateToUrInsideInnerTab(url: string, tab: IInnerTab) {
    window.dsDesktop.tabs.navigateToUrInsideInnerTab(url, tab);
  }

  sendNewUpdateRecording(
    tab: IGlobalTab,
    organizationId: number,
    recordingId: number
  ) {
    window.dsDesktop.recorder.sendNewUpdateRecording(
      tab,
      organizationId,
      recordingId
    );
  }

  focusApp() {
    window?.dsDesktop?.app?.focusApp();
  }
  blurApp() {
    window?.dsDesktop?.app?.blurApp();
  }
  isAppViewFocus() {
    return window?.dsDesktop?.app?.isAppViewFocus();
  }
}
const rendererService = new RendererService();
export default rendererService;
